import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, InputNumber, Select, DatePicker } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";
import { DATE_FORMAT, MODULE_INVOICES } from "variables/constants";
import { getClientList, getForexList } from "../../../../redux/optionlist/optionlistState";
import { doCreateSelectionNoticeInvoice } from "../../../../redux/invoice/invoiceState";

const SNInvoiceForm = ({getClientOptions, getForexOptions, forexList, doCreateInvoice, clientList = []}) => {
	
  	const [form] = useForm();
  	
  	useEffect(() => {
        getClientOptions({asOptions: 1, for_invoice: 1});
	}, [getClientOptions]);

	useEffect(() => {
        getForexOptions({asOptions: 1});
	}, [getForexOptions]);

	const forexOptions = [
		{
			value: 0,
			label: "Manual",
		},
		...forexList,
	];

	const handleForexChange = (value) => {
		if(value === 0) {
			form.setFieldsValue({
				inv_forex_usd: null,
				inv_forex_aud: null,
			});
		}else{
			const selectedForex = forexList.find(forex => Number(forex.value) === Number(value));
			if(selectedForex) {
				form.setFieldsValue({
					inv_forex_usd: Number(selectedForex.usd),
					inv_forex_aud: Number(selectedForex.aud),
				});
			}
		}
	};

  	const onSubmit = (formData) => {	
    	try {  		
			const { inv_issue_date, inv_due_date, created_at, ...forSubmitValues } = formData;			  
			forSubmitValues.inv_issue_date = inv_issue_date ? inv_issue_date.format(DATE_FORMAT) : null;
			forSubmitValues.inv_due_date = inv_due_date ? inv_due_date.format(DATE_FORMAT) : null;
			doCreateInvoice(forSubmitValues);
    	} catch (error) {
      		console.error('Generate failed:', error);
    	}
  	};

  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
				<h2 className="font-medium text-[18px] mb-4">Create Selection Notice Invoice</h2>
        		<div className="grid grid-cols-1 md:grid-cols-4 gap-4"> 
					<FormItem 
		            	name="client_id"
		                label="Client"
						rules={[requiredField()]}
		            >
		            	<Select 
							id="client_id"
							className="input-field"
		            		options={clientList}
							allowClear
							showSearch
		            	/>
	            	</FormItem>

					<FormItem className="font-medium mb-2"
						name="employee_name"
						label="Employee Name"
						rules={[requiredField()]}
					>
						<Input type="text" 
							id="employee_name"
							className="input-field"
							maxLength={100}
							placeholder="Employee Name"
						/>
					</FormItem> 

					<FormItem className="font-medium mb-2"
						name="employee_salary"
						label="Employee Salary"
						rules={[ requiredField(),
						{
							pattern: /^\d{1,8}(\.\d{1,2})?$/,
							message: "Enter a valid amount (max 99999999.99, up to 2 decimal places)",
						}
						]}
					>
						<Input type="text" 
							id="employee_salary"
							className="input-field"
							maxLength={12}
							placeholder="0.00"
						/>
					</FormItem> 

					<FormItem className="font-medium mb-2"
						label="Date Start"
						name="date_start"
						rules={[requiredField()]}
					>
						<DatePicker id="date_start"
							className="input-field"
							format={DATE_FORMAT}
							style={{ width: "100%" }}
						/>
					</FormItem> 

					<FormItem 
		            	name="inv_forex_id"
		                label="Forex"
						rules={[requiredField()]}
		            >
		            	<Select 
							id="inv_forex_id"
							className="input-field"
		            		options={forexOptions}
							allowClear
							showSearch
							onChange={handleForexChange}
		            	/>
	            	</FormItem>
					<FormItem 
						name="inv_forex_usd"
						label="PHP to USD"
						hidden
					>
						<Input type="hidden" id="inv_forex_usd"/>
					</FormItem>
					<FormItem 
						name="inv_forex_aud"
						label="PHP to AUD"
						rules={[requiredField()]}
					>
						<InputNumber precision={4}
							id="inv_forex_aud"
							className="input-field aligned-right-number"
							style={{
								width: 150,
							}}
						/>
					</FormItem>
					<FormItem 
						label="Invoice Date"
						name="inv_issue_date"
						rules={[requiredField()]}
					>
						<DatePicker id="inv_issue_date"
							className="input-field"
							format={DATE_FORMAT}
							style={{ width: "100%" }}
						/>
					</FormItem>
					<FormItem 
						label="Due Date"
						name="inv_due_date"
						rules={[requiredField()]}
					>
						<DatePicker id="inv_due_date"
							className="input-field"
							format={DATE_FORMAT}
							style={{ width: "100%" }}
						/>
					</FormItem>
	 			</div>		
				<CrudButtons 
					baseRoute="/console/invoices" 
					mode="edit" 
					recordId={0} 
					submitLabel="Save"
					moduleId={MODULE_INVOICES}
				/> 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
	clientList: state.optionlist.clientList?.items || [],
	forexList: state.optionlist.forexList?.items || [],
});

const mapDispatchToProps = (dispatch) => ({
	getClientOptions: (data) => dispatch(getClientList(data)),
	getForexOptions: (data) => dispatch(getForexList(data)),
	doCreateInvoice: (data) => dispatch(doCreateSelectionNoticeInvoice(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SNInvoiceForm);
